<template>
  <div class="w-full flex flex-col mt-2 pr-2 sm:pr-5 min-w-0">
    <label class="text-[var(--color-disabled)] text-lg">{{ textQuestion }}</label>
    <label class="text-lg break-words">{{ question.answer }}</label>
  </div>
</template>
<script>
export default {
  name: 'ReflexionGuidelineTextFieldResponse',
  props: {
    question: Object,
  },
  components: {},
  computed: {
    textQuestion() {
      if (this.$i18n.locale === 'de') {
        return this.question.question_de;
      }
      return this.question.question_en;
    },
  },
};
</script>
